var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('header-due-elle',{attrs:{"width":_vm.width}}),_c('router-view',{attrs:{"height":_vm.height,"width":_vm.width}}),_c('footer-due-elle')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }